import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { refreshToken } from "../views/Auth/SignIn/refreshToken";

// Base fetch with access token from localStorage
const baseQuery = fetchBaseQuery({
  baseUrl: "",
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

// Type guard for originalStatus
function hasOriginalStatus(
  error: FetchBaseQueryError
): error is FetchBaseQueryError & { originalStatus: number } {
  return (error as any).originalStatus !== undefined;
}

// Custom fetch that retries with new token on 401
const customFetchBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

 if (
  result.error &&
  hasOriginalStatus(result.error) &&
  (result.error.originalStatus === 401 || result.error.originalStatus === 500)
) {
    const newToken = await refreshToken();

    if (newToken) {
      let updatedHeaders: HeadersInit = {
        Authorization: `Bearer ${newToken}`,
      };

      // Safely copy other headers if available
      if (typeof args === "object" && "headers" in args && args.headers) {
        const headers = args.headers;
        if (headers instanceof Headers) {
          headers.set("Authorization", `Bearer ${newToken}`);
          return await baseQuery(args, api, extraOptions);
        } else if (Array.isArray(headers)) {
          updatedHeaders = [
            ...(headers as [string, string][]),
            ["Authorization", `Bearer ${newToken}`],
          ];
        } else if (typeof headers === "object") {
          updatedHeaders = {
            ...headers,
            Authorization: `Bearer ${newToken}`,
          };
        }
      }

      const updatedArgs: FetchArgs =
        typeof args === "string"
          ? { url: args, headers: updatedHeaders }
          : { ...args, headers: updatedHeaders };

      result = await baseQuery(updatedArgs, api, extraOptions);
    } else {
      localStorage.clear();
      window.location.href = "/sign-in";
    }
  }

  return result;
};

// Create API slice
export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: customFetchBaseQuery,
  tagTypes: ["Restaurant", "Order", "Menus", "ProductionPlans", "ProductionPlan","DistributionBasicPlan","CartDistributionPlans","Orders","CartLoading","CartLoadingDetail", "Dimensions", "DimensionValues", "MenuTypes", "Products", "Carts", "Allocations","CartAllocations", "Holidays"],
  endpoints: (builder) => ({}),
});
